/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name groupby
 */
angular.module('mercury.filters.groupby', [])
.filter('groupby', function() {
  return function(dataArray, key) {
    var result = {};
    angular.forEach(dataArray, function(object) {
      var keyValue = object[key];
      if (keyValue) {
        if (!result[keyValue]) {
          result[keyValue] = [object];
        } else {
          result[keyValue].push(object);
        }
      }
    });

    var resultArray = [];
    angular.forEach(result, function(resultGroup) {
      resultArray.push(resultGroup);
    });

    return resultArray;
  };
});
